import type { StepInputProps } from './StepInput'

const options = [
  { value: '0', label: 'Ingen skader' },
  { value: '1', label: '1 skade' },
  { value: '2', label: '2 skader' },
  { value: '3+', label: '3 eller flere' },
] as const

export function ClaimsInput({ state, onSubmit }: StepInputProps) {
  return (
    <div className="input-dock">
      <div className="chip-group">
        {options.map((opt) => (
          <button
            key={opt.value}
            className={`chip-option ${state.claims === opt.value ? 'selected' : ''}`}
            onClick={() => onSubmit({ claims: opt.value })}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )
}
